import {
    handleArrow,
    getSuggestionsWrapper,
} from '@assets/components/search';
import { debounce } from 'lodash';

const endpoint = $('.suggestions-wrapper').data('url');
const minChars = 1;
const UP_KEY = 38;
const DOWN_KEY = 40;
const DIRECTION_DOWN = 1;
const DIRECTION_UP = -1;

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
export function clearModals() {
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
export function processResponse(response) {
    const $suggestionsWrapper = getSuggestionsWrapper(this).empty();
    const $mayLikeSearch = $('.may-like-search');

    if (typeof response !== 'object') {
        if ($mayLikeSearch.length > 0) $mayLikeSearch.removeClass('d-flex').addClass('d-none');
        $suggestionsWrapper.append(response).show();
        $(this).siblings('.reset-button').addClass('d-sm-block');

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        const suggestionsList = $('.suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr(
                'aria-describedby',
                'search-result-count',
            );
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
        if ($mayLikeSearch.length > 0) $mayLikeSearch.addClass('d-flex').removeClass('d-none');
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
export function getSuggestions(scope) {
    const $resetButton = $(scope).closest('form').find('.reset-button');
    const $mayLikeSearch = $('.may-like-search');
    if ($(scope).val().length >= minChars) {
        $resetButton.removeClass('d-none');
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error(e) {
                console.error(e);
            },
        });
    } else {
        $resetButton.addClass('d-none');
        if ($mayLikeSearch.length > 0) $mayLikeSearch.addClass('d-flex').removeClass('d-none');
        clearModals();
        getSuggestionsWrapper(scope).empty();
    }
}

export default class Search {
    constructor() {
        this.searchModal = $('#searchModal');
        this.allSearchInput = $('input.search-field');
        this.searchInput = $('#searchModal-input');
        this.form = $('form[name="simpleSearch"]');
        this.closeSearchButton = this.searchModal.find('.close-button');
        this.resetButton = this.searchModal.find('.reset-button');
        this.submitSearchButton = this.searchModal.find(
            '.submit-search-button',
        );
        this.mayLikeSearch = this.searchModal.find('.may-like-search');
    }

    init() {
        this.onModalShow();
        this.onModalHide();
        this.onSearchInput();
        this.onFormSubmit();
        this.onResetButton();
        this.closeSearchButton.on('click', this.closeSearchModal.bind(this));
    }

    onFormSubmit() {
        this.form.on('submit', (e) => {
            const suggestionsList = $('.suggestions .item');
            if (suggestionsList.filter('.selected').length !== 0) {
                e.preventDefault();
                suggestionsList.filter('.selected').find('a')[0].click();
            }
        });
    }

    onSearchInput() {
        this.allSearchInput.each(function () {
            const debounceSuggestions = debounce(getSuggestions, 300);
            $(this).on('keyup focus', function (e) {
                switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault();
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault();
                    break;
                default:
                    debounceSuggestions(this, e);
                }
            });
        });
    }

    closeSearchModal() {
        this.searchModal.modal('hide');
    }

    onResetButton() {
        this.resetButton.on('click', (e) => {
            const $resettedInput = $(e.target).closest('form').find('.search-field');
            $resettedInput.val('');
            getSuggestions($resettedInput[0]);
        });
    }

    onModalHide() {
        this.searchModal.on('hidden.bs.modal', () => {
            this.searchInput.val('');
            clearModals();
        });
    }

    onModalShow() {
        this.searchModal.on('shown.bs.modal', () => {
            this.searchInput.trigger('focus');
        });
    }
}
